// extracted by mini-css-extract-plugin
module.exports = {"wp_pop":"style_wp_pop__3VBWv","wp_tips":"style_wp_tips__2N1BN"};